import axios from 'axios';
import CustomSelect from '../../components/form/custom-select';
import Observer from '../../common/scripts/observer';
import progressListTemplate from './templates/progress-list.twig';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class Progress {
    constructor() {
        /**
         * Целевой элемент
         */
        this.wrapper = null;

        /**
         * URL для отправки формы
         */
        this.action = null;

        /**
         * Шаблон вывода данных
         */
        this.template = null;

        /**
         * Обёртка для вывода данных/контента
         */
        this.listWrapper = null;

        /**
         * Данные полученные с бэка для вывода на страницу
         */
        this.progressData = null;

        /**
         * Обёртка селектора с датой
         */
        this.selectWrapper = null;

        /**
         * Обёртка для контента
         */
        this.contentWrapper = null;

        /**
         * Элементы навигации/переход к следующей/предыдущей дате
         */
        this.navigation = null;
    }

    init(options) {
        this.wrapper = options.wrapper;

        this._getElements();
        this._setTemplate();

        if (this.selectWrapper) {
            this._initCustomSelect();
            this._send();
        }

        this._bindEvents();
        this._observerSubscribe();
    }

    /**
     * Получает элементы для дальнейшей работы
     * @private
     */
    _getElements() {
        this.selectWrapper = this.wrapper.querySelector('.j-progress-select');
        this.action = this.selectWrapper.dataset.action;
        this.listWrapper = this.wrapper.querySelector('.j-progress-content');
        this.contentWrapper = this.wrapper.querySelector('.j-progress-wrapper');
        this._getNavigation();
    }

    /**
     * Получает элементы навигации
     * @private
     */
    _getNavigation() {
        this.navigation = Array.from(this.wrapper.querySelectorAll('.j-progress-nav'));
    }

    /**
     * Устанавливает шаблон вывода данных
     * @private
     */
    _setTemplate() {
        this.template = progressListTemplate;
    }

    /**
     * Инициализация кастомных селектов
     * @private
     */
    _initCustomSelect() {
        this.select = new CustomSelect({
            elem: this.selectWrapper
        });

        this.select.init();

        this._bindEventsSelect();
    }

    /**
     * Привязка событий к селекту
     * @private
     */
    _bindEvents() {
        const inputs = Array.from(this.selectWrapper.querySelectorAll('input'));

        this.navigation.forEach((nav) => {
            const id = nav.dataset.id;

            nav.addEventListener('click', () => {
                const active = inputs.find((item) => {
                    return item.checked;
                });
                const input = inputs.find((item) => {
                    return item.id === id;
                });

                active.checked = false;
                input.checked = true;

                this.select.update([{
                    elem: this.selectWrapper
                }]);
                this._scrollTop();

                setTimeout(() => {
                    this._send();
                }, 300);
            });
        });
    }

    /**
     * Привязка событий к селекту
     * @private
     */
    _bindEventsSelect() {
        this.selectWrapper.addEventListener('change', () => {
            this._send();
        });
    }

    /**
     * Метод отправляет данные на сервер.
     * @private
     */
    async _send() {
        this.formData = this._collectData();

        this._toggleLoading();

        await axios.post(this.action, this.formData)
            .then((response) => {
                const success = response.data.success;

                if (success) {
                    this.progressData = response.data.data;

                    this._setTemplateData();
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                this._toggleLoading();
            });
    }

    /**
     * Прокручивает к началу страницы
     * @private
     */
    _scrollTop() {
        window.scrollTo({
            top     : 0,
            behavior: 'smooth'
        });
    }

    /**
     * Собирает данные для отправки
     * @return {FormData} - formData
     * @private
     */
    _collectData() {
        const formData = new FormData();
        const options = this.select.getOptions();
        const activeSelect = options.find((item) => {
            return item.checked;
        });

        formData.append('select', activeSelect.value);

        return formData;
    }

    /**
     * Устанавливает данные в шаблон
     * @private
     */
    _setTemplateData() {
        const {list, prev, next} = this.progressData;
        const navigation = {
            prev,
            next
        };
        const content = {
            list,
            navigation
        };

        Utils.clearHtml(this.listWrapper);
        Utils.insetContent(this.listWrapper, this.template(content));

        this._observerPublish(this.listWrapper);
        this._getNavigation();
        this._bindEvents();
    }

    /**
     * Подписываемся на события
     * @private
     */
    _observerSubscribe() {
        observer.subscribe('popup:open', (popup) => {
            if (!popup.content) {
                return;
            }

            this._observerPublish(popup.content, false);
        });
    }

    /**
     * Обновленией наблюдателей
     * @param {object} container - контейнер где обновляем
     * @param {boolean} newContent - нужно ли обновлять lazyLoad
     * @private
     */
    _observerPublish(container, newContent = true) {
        if (newContent) {
            observer.publish('lazyLoad:refresh', container);
            observer.publish('popup:refresh', container);
        }

        observer.publish('swiper-carousel:refresh', container);
        observer.publish('toggle:refresh', container);
    }

    /**
     * Переключает лоадер вкл/выкл
     * @private
     */
    _toggleLoading() {
        this.contentWrapper.classList.toggle('is-loading');
    }
}

export default Progress;
